import React from 'react'

import Cta from '@/components/blocks-library/cta/cta'

import * as style from './subscribe-form.module.scss'

type SubscribeFormProps = Queries.DatoCmsBannerWithCta

const SubscribeForm: React.FC<SubscribeFormProps> = ({ title, text, cta }) => {
  const thisCta = cta && cta.length > 0 ? cta[0] : null

  return (
    <section className={`${style.section} bg-base-000`}>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className={`h200 text-base-1000 my-0 ${style.title}`}>
              {title}
            </h2>
          </div>
          <div className="col-12 col-md-6 text-center offset-md-3">
            <p className={`b200 text-base-1000 ${style.subtitle}`}>{text}</p>
            {thisCta && (
              <Cta
                key={thisCta.text}
                color="custom"
                className={`${style.button}`}
                {...thisCta}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SubscribeForm
